/* eslint-disable react/function-component-definition,jsx-a11y/control-has-associated-label */
import clsx from "clsx";
import React, { useMemo } from "react";
import "./Table.scss";

const ARROW_UP_STYLES = {
  asc: "Uic-Table-sortHighlighted",
  desc: "Uic-Table-sortOff",
};

const ARROW_DOWN_STYLES = {
  asc: "Uic-Table-sortOff",
  desc: "Uic-Table-sortHighlighted",
};

const sortCaret = (loading) => (order) =>
  (
    <button type="button" className="Uic-Table-sortCaret" disabled={loading}>
      <span className={clsx("fa fa-arrow-down", ARROW_DOWN_STYLES[order])} />
      &nbsp;
      <span className={clsx("fa fa-arrow-up", ARROW_UP_STYLES[order])} />
    </button>
  );

const useSort = ({ loading }) => {
  const sort = useMemo(
    () => ({
      sortCaret: sortCaret(loading),
    }),
    [loading]
  );

  return sort;
};

export default useSort;
